const ResponseError = require('./ResponseError');

class RetriableResponseError extends ResponseError {

}

module.exports = RetriableResponseError;
